import { ThemeEvents } from '@theme/events';

/**
 * Keeps the saving pill in step with the selected variant.
 *
 * Changing a variant on the product page morphs only the variant picker itself;
 * every other part of the panel that depends on the variant listens for the
 * update and pulls its own replacement out of the HTML that came back with it.
 * That is how Horizon's own price block stays current, and this follows it.
 *
 * A variant with no compare-at price renders no pill at all, so the element can
 * come back empty — which is the right outcome, and why the element itself stays
 * in place rather than being replaced.
 */
class SensiaSavings extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const replacement = html.querySelector(`sensia-savings[data-block-id="${this.dataset.blockId}"]`);
    if (!replacement) return;

    this.replaceChildren(...replacement.cloneNode(true).childNodes);
  };
}

if (!customElements.get('sensia-savings')) {
  customElements.define('sensia-savings', SensiaSavings);
}
